import type { LatLng } from '~/_shared/types/latLng';
import { type ActiveMarker } from '~/_shared/types/marker.types';
import type { SpreadsheetRowId } from '~/_shared/types/spreadsheetData/spreadsheetRow';
import type { PlaceId } from '~/places/places.types';
import { type ActiveProximity } from '~/sidebar/sidebarApps/rightSidebar/rightSidebarConfiguration';
import {
  type BoundaryTerritoryIdentifier, type ExtendedBoundaryIdentifier,
} from '~/store/boundaries/boundaryIdentifier.type';
import type { PlacesSearchId } from '~/store/mapSettings/places/mapSettingsPlaces.state';

export type ActiveMapElementsState = Readonly<{
  activeMarker: ActiveMarker | null;
  activeMarkerNavigationIndex: number;
  activeBoundary: ExtendedBoundaryIdentifier | null;
  activeBoundaryTerritory: BoundaryTerritoryIdentifier | null;
  activeOverlappingElements: ActiveOverlappingMapElements;
  activeProximity: ActiveProximity | null;
  activePlace: ActivePlace | null;
  hoveredMarker: ActiveMarker | null;
  hoveredProximity: ActiveProximity | null;
  isLocationListActive: boolean;
  isMasterKeyActive: boolean;
  spreadsheetPreviewFilterState: SpreadsheetPreviewFilterState;
}>;

export type ActiveOverlappingMapElements = Readonly<{
  activeOverlappingLocation: LatLng | null;
  boundaries: ReadonlyArray<OverlappingBoundaryTerritory>;
  proximities: ReadonlyArray<OverlappingProximity>;
  configuration: ActiveMapElementsConfiguration | null;
}>;

export enum ActiveMapElementsConfiguration {
  BoundaryTerritory = 'BoundaryTerritory',
  Proximity = 'Proximity',
}

export type OverlappingProximity = Readonly<{
  proximityId: string;
  spreadsheetRowId?: SpreadsheetRowId;
}>;

export type OverlappingBoundaryTerritory = Readonly<{
  boundaryTerritoryId: string;
}>;

export type ActivePlace = Readonly<{
  id: PlaceId;
  placeSearchId: PlacesSearchId;
}>;

export type SpreadsheetPreviewFilterState = Readonly<{
  boundaries: ReadonlyArray<ExtendedBoundaryIdentifier>;
  boundaryTerritories: ReadonlyArray<BoundaryTerritoryIdentifier>;
  proximities: ReadonlyArray<ActiveProximity>;
}>;
